import module from 'nominas/sumario/module.js'
import template from './template.html'
import { isDate, orderBy } from 'lodash'
import * as moment from 'moment'

export class NominasSumarioComponent {
  busqueda
  promise
  data
  permisos
  catalogo = {
    proyectos: [],
  }

  constructor ($state, $q, $catalogos, Permisos) {
    this.$state = $state
    this.$q = $q
    this.$catalogos = $catalogos
    this.Permisos = Permisos
  }

  $onInit () {
    this.busqueda = {
      idProyectos: this.busqueda.idProyectos,
      fechaInicial: isDate(this.busqueda.fechaInicial) ? this.busqueda.fechaInicial : moment().startOf('month').toDate(),
      fechaFinal: isDate(this.busqueda.fechaFinal) ? this.busqueda.fechaFinal : moment().endOf('month').toDate(),
      idMoneda: +this.busqueda.idMoneda || 1,
      idTipoNomina: +this.busqueda.idTipoNomina || null,
      importe: this.busqueda.importe >= 0 ? +this.busqueda.importe : null,
      estatus: +this.busqueda.estatus || null,
    }

    this.promise = this.$q.all([
      this.Permisos.modulos({revisar: 'kendu.nominas.sumarioNominas.revisar'})
        .then((data) => (this.permisos = data)),
      this.$catalogos.get('empresas')
        .then((data) => data.map((item) => ({id: item.ID_Empresa, descripcion: item.Nombre})))
        .then((data) => (this.catalogo.proyectos = orderBy(data, ['descripcion']))),
    ])
  }

  buscar () {
    let busqueda = {
      fechaInicial: moment(this.busqueda.fechaInicial).format('YYYY-MM-DD'),
      fechaFinal: moment(this.busqueda.fechaFinal).format('YYYY-MM-DD'),
      idProyectos: this.busqueda.idProyectos,
      idMoneda: this.busqueda.idMoneda,
      importe: this.busqueda.importe || undefined,
      idTipoNomina: this.busqueda.idTipoNomina || undefined,
      estatus: this.busqueda.estatus || undefined,
    }

    this.$state.go(this.$state.current, busqueda, {reload: true})
  }
}

module.component('nominasSumario', {
  controller: NominasSumarioComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/components/component.js